module.exports = __webpack_public_path__ + "img/honor0.3b3b5c51.jpg";